module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('router-link', {
    staticClass: "pull-right",
    attrs: {
      "to": "/liquidaciones/clientes"
    }
  }, [_vm._v("Volver a la lista")])], 1), _vm._v(" "), (_vm.liquidacion) ? _c('div', {
    ref: "detalle",
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "box-header text-center"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_vm._v("Liquidacion N° " + _vm._s(_vm.liquidacion.numero))]), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.liquidacion.empresa.empresa.razonSocial) + " - " + _vm._s(_vm.liquidacion.empresa.denominacion))]), _vm._v(" "), _c('div', {
    staticClass: "box-date"
  }, [_c('b', [_vm._v(_vm._s(_vm.liquidacion.estado))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('p', {
    staticClass: "size-14"
  }, [_c('b', [_vm._v("Cantidad de Entregas:")]), _vm._v("\n                  " + _vm._s(_vm.liquidacion.entregas.length) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Emitida el:")]), _vm._v("\n                  " + _vm._s(_vm._f("formatFecha")(_vm.liquidacion.fechaCreacion)) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Monto total de pedidos:")]), _vm._v("\n                  " + _vm._s(_vm._f("formatMoneda")(_vm.montoTotalPedidos)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('p', {
    staticClass: "size-14"
  }, [_c('b', [_vm._v("Monto total subsididado en pedidos:")]), _vm._v("\n                      " + _vm._s(_vm._f("formatMoneda")(_vm.montoTotalSubsidiadoPedidos)) + "\n                      "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Monto a pagar por usuarios:")]), _vm._v("\n                      " + _vm._s(_vm._f("formatMoneda")(_vm.montoPagarUsuarios)) + "\n                      "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Exportar Liquidación")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-grey-green",
    on: {
      "click": function($event) {
        _vm.exportXls(false)
      }
    }
  }, [_vm._v("\n                  EXCEL\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-grey-green",
    on: {
      "click": function($event) {
        _vm.exportPdf(false)
      }
    }
  }, [_vm._v("\n                  PDF\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row box-header"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-3",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_vm._v("EMPLEADO")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    ref: "slUsuario",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.usuariosDistinct), function(usuario) {
    return _c('option', {
      key: usuario._id,
      domProps: {
        "value": usuario._id
      }
    }, [_vm._v(_vm._s(usuario.displayName))])
  })), _vm._v(" "), _c('a', {
    staticClass: "disable-filter hide",
    class: {
      show: _vm.filtros.empleados.length > 0
    },
    on: {
      "click": _vm.quitarFiltrosEmpleado
    }
  }, [_vm._v("Quitar filtro empleado")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-2",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_vm._v("COMBO")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    ref: "slCombo",
    staticClass: "form-control select2 filter-select2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "data-select2-container": "big-text"
    }
  }, _vm._l((_vm.combos), function(combo) {
    return _c('option', {
      key: combo._id,
      domProps: {
        "value": combo._id
      }
    }, [_vm._v(_vm._s(combo.nombre))])
  })), _vm._v(" "), _c('a', {
    staticClass: "disable-filter hide",
    class: {
      show: _vm.filtros.combos.length > 0
    },
    on: {
      "click": _vm.quitarFiltrosCombo
    }
  }, [_vm._v("Quitar filtro combos")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_vm._v("DESDE")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "max-date": new Date()
    },
    model: {
      value: (_vm.filtros.desde),
      callback: function($$v) {
        _vm.filtros.desde = $$v
      },
      expression: "filtros.desde"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "disable-filter hide",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Quitar filtro fecha")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-3",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('label', [_vm._v("HASTA")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "max-date": new Date()
    },
    model: {
      value: (_vm.filtros.hasta),
      callback: function($$v) {
        _vm.filtros.hasta = $$v
      },
      expression: "filtros.hasta"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "disable-filter hide",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Quitar filtro fecha")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-1",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("EXPORTAR SELECCIONADOS")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportXls(true)
      }
    }
  }, [_vm._v("EXCEL")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exportPdf(true)
      }
    }
  }, [_vm._v("PDF")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('p', {
    staticClass: "size-14"
  }, [_c('b', [_vm._v("Cantidad de Entregas:")]), _vm._v("\n                  " + _vm._s(_vm.entregasFiltradas.length) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('p', {
    staticClass: "size-14"
  }, [_c('b', [_vm._v("Monto total de pedidos:")]), _vm._v("\n                  " + _vm._s(_vm._f("formatMoneda")(_vm.montoTotalPedidosFiltrados)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('p', {
    staticClass: "size-14"
  }, [_c('b', [_vm._v("Monto total subsididado en pedidos:")]), _vm._v("\n                      " + _vm._s(_vm._f("formatMoneda")(_vm.montoTotalSubsidiadoPedidosFiltrados)) + "\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('p', {
    staticClass: "size-14"
  }, [_c('b', [_vm._v("Monto a pagar por usuarios:")]), _vm._v("\n                      " + _vm._s(_vm._f("formatMoneda")(_vm.montoPagarUsuariosFiltrados)) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "lista"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), (_vm.liquidacion.entregas.length > 0) ? _c('tbody', [_vm._l((_vm.entregasPaginadas), function(entrega) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(entrega.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.usuario.displayName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.usuario.legajo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(entrega.fechaEntrega)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(entrega.montoBruto)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(entrega.montoSubsidiado)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-link btn-xs",
      on: {
        "click": function($event) {
          entrega.verDetalle = !entrega.verDetalle
        }
      }
    }, [_vm._v("Ver detalle")])])]), _vm._v(" "), (entrega.verDetalle) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": "5"
      }
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('tbody', _vm._l((entrega.platos), function(plato) {
      return _c('tr', [_c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(plato.cantidad) + "x")]), _vm._v(" "), _c('td', {
        attrs: {
          "colspan": "3"
        }
      }, [_vm._v(_vm._s(plato.plato.nombre))])])
    }))])])]) : _vm._e()]
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.paginador.totalItems > 0) ? _c('div', {
    staticClass: "smart-form"
  }, [_c('div', {
    staticClass: "text-center center-block"
  }, [_c('nav', {
    attrs: {
      "aria-label": "Page navigation"
    }
  }, [_c('ul', {
    staticClass: "pagination pagination-sm"
  }, [_c('li', [_c('a', {
    attrs: {
      "aria-label": "Anterior"
    },
    on: {
      "click": function($event) {
        _vm.goToPrevPage()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Página " + _vm._s(_vm.paginador.currentPage) + " de " + _vm._s(_vm.paginador.totalPages))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "aria-label": "Siguiente"
    },
    on: {
      "click": function($event) {
        _vm.goToNextPage()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "usuarios"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.entregasAgrupadasUsuario), function(entregasUsuario, idx) {
    return [_c('tr', {
      key: entregasUsuario.idUser
    }, [_c('td', [(entregasUsuario.user.legajo) ? _c('span', [_vm._v(_vm._s(entregasUsuario.user.legajo) + " - ")]) : _vm._e(), _vm._v(_vm._s(entregasUsuario.user.displayName))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(entregasUsuario.entregas.length))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(_vm._f("montoTotal")(entregasUsuario.entregas))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(_vm._f("totalSubsidiadoUsuario")(entregasUsuario.entregas))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(_vm._f("totalPagadoUsuario")(entregasUsuario.entregas))))]), _vm._v(" "), _c('td', [_c('button', {
      key: entregasUsuario.idUser,
      staticClass: "btn btn-link btn-xs js-detalle",
      on: {
        "click": function($event) {
          entregasUsuario.mostrarDetalle = !entregasUsuario.mostrarDetalle
        }
      }
    }, [_vm._v("Ver detalle")])])]), _vm._v(" "), _c('tr', {
      key: entregasUsuario.idUser,
      staticClass: "table-detalle hidden"
    }, [_c('td', {
      staticStyle: {
        "background-color": "#EEE"
      },
      attrs: {
        "colspan": "6"
      }
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_vm._m(4, true), _vm._v(" "), _c('tbody', [_vm._l((entregasUsuario.entregas), function(entrega) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(entrega.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(entrega.fechaEntrega)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.combo.nombre))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("formatMoneda")(entrega.montoBruto)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(_vm._f("formatMoneda")(entrega.montoSubsidiado)))]), _vm._v(" "), _c('td', [_c('button', {
        key: entregasUsuario.idUser,
        staticClass: "btn btn-link btn-xs js-detalle"
      }, [_vm._v("Ver detalle")])])]), _vm._v(" "), _c('tr', {
        staticClass: "hidden table-detalle"
      }, [_c('td', {
        attrs: {
          "colspan": "5"
        }
      }, [_c('b', [_vm._v("Platos del pedido " + _vm._s(entrega.numero) + ": ")]), _vm._v(_vm._s(_vm._f("platosSerialized")(entrega.platos)) + "\n                                              ")])])]
    })], 2)])])])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "movimientos"
    }
  }, [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Movimientos registrados para la liquidación " + _vm._s(_vm.liquidacion.numero))]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.movimientosFiltrados), function(movimiento) {
    return _c('tr', {
      key: movimiento._id
    }, [_c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(movimiento.fecha)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(movimiento.tipo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(movimiento.comprobante))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("formatMoneda")(movimiento.importe)))])])
  }))])])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "contenedorExport",
    staticClass: "hidden"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-outline-grey-green dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                        Exportar  "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#lista",
      "aria-controls": "lista",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Lista de pedidos")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#usuarios",
      "aria-controls": "usuarios",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Agrupada por usuarios")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#movimientos",
      "aria-controls": "movimientos",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Movimientos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Pedido por")]), _vm._v(" "), _c('th', [_vm._v("Legajo")]), _vm._v(" "), _c('th', [_vm._v("Fecha entrega")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto pedido")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto subsidiado")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Usuario")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Pedidos")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto total")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto subsidiado")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto pagado por usuario")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Número")]), _vm._v(" "), _c('th', [_vm._v("Fecha entrega")]), _vm._v(" "), _c('th', [_vm._v("Combo")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto total")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto subsididado")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', [_vm._v("Comprobante")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Monto")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b4d1448"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Liquidaciones/DetalleLiquidacionCliente.vue
// module id = 1133
// module chunks = 5